


export const sendEmail = (to, subject, body, phone, name) => {
    fetch(`http://localhost:4000/api/mail/`, {
        body: JSON.stringify({ to, subject, body, phone, name }),
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    })
        .then(res => res.json())
        .then(data => {
            console.log(data)
        })
        .catch(err => {
            console.log(err)
        })
}